import {
  ChangeEvent,
  forwardRef,
  InputHTMLAttributes,
  useEffect,
  useMemo,
  useState,
} from "react";
import { withValidate } from "./withValidate";
import { twMerge } from "tailwind-merge";
import { IconCheckbox } from "./Icon/Checkbox";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  title?: string;
  desc?: string;
  subTitle?: string;
  onClick?: () => void;
}
export const Checkbox = forwardRef<HTMLInputElement, InputProps>(
  ({ className, desc, title, onChange, subTitle, onClick, ...props }, ref) => {
    const [_checked, setChecked] = useState(props?.defaultChecked);
    const checked = useMemo(
      () => props?.checked ?? _checked,
      [props?.checked, _checked]
    );
    const handleChecked = (e: ChangeEvent<HTMLInputElement>) => {
      setChecked(e.target.checked);
      onChange?.(e);
    };
    useEffect(() => {
      setChecked(props?.defaultChecked);
    }, [props?.defaultChecked]);
    return (
      <label className={twMerge("inline-flex gap-2", className)}>
        <input
          {...props}
          onChange={handleChecked}
          type="checkbox"
          ref={ref}
          className="hidden"
        />
        <IconCheckbox active={checked} />
        <div>
          {title && (
            <p className="text-sm mt-0.5">
              {title}
              {subTitle && (
                <p onClick={onClick} className="text-sm mt-0.5 text-orange-400">
                  {subTitle}
                </p>
              )}
            </p>
          )}
          {desc && (
            <p className="text-[#999] text-[13px] leading-[16.9px] mt-1">
              {desc}
            </p>
          )}
        </div>
      </label>
    );
  }
);
export const ValidateCheckbox = withValidate(Checkbox);
